/**
 * Staff permissions, finer than a role (DEV-112).
 *
 * The admin session token carries them as the `perms` claim so the back office
 * can hide or explain what the server would refuse. The server never takes the
 * token's word for it: it reads the staff record on every guarded decision.
 */

/** May clear or keep "EDD required" for a customer with no EDD case. */
export const CAN_APPROVE_EDD = 'can_approve_edd';

export type StaffPermission = typeof CAN_APPROVE_EDD;

const KNOWN: readonly string[] = [CAN_APPROVE_EDD];

/** Known permissions only, whatever the token or an old stored session holds. */
export function toStaffPermissions(raw: unknown): StaffPermission[] {
  if (!Array.isArray(raw)) return [];
  return KNOWN.filter((p): p is StaffPermission => raw.includes(p));
}

/** True when this signed-in staff member's session carries the permission. */
export function holdsPermission(
  viewer: { permissions?: readonly string[] | undefined } | null | undefined,
  permission: StaffPermission,
): boolean {
  return viewer?.permissions?.includes(permission) === true;
}
